export enum Url {
  LOGIN = '/v0/auth/seller/login',
  CATEGORY_TREE = '/v0/category/full',
  CATEGORY = '/v0/category',
  COUNTRIES = '/v0/countries/full',
  COUNTRY = '/v0/countries',
  BRAND = '/v0/brand',
  BRAND_UPLOAD = '/v0/brand/upload',
  FEATURES_FULL = '/v0/features/full',
  FEATURES = '/v0/features',
  GIFT_TYPE_FULL = '/v0/gift-type/full',
  GIFT_CATEGORY = '/v0/gift-category',
  GIFT_CATEGORY_UPLOAD = '/v0/gift-category/upload',
  GIFT_CATEGORY_FULL = '/v0/gift-category/full',
  GIFT_TYPE = '/v0/gift-type',
  SPECIFICATION_CATEGORY_FULL = '/v0/specification-categories/full',
  SPECIFICATION_CATEGORY = '/v0/specification-categories',
  SPECIFICATION_FULL = '/v0/specification/full',
  SPECIFICATION = '/v0/specification',
  SLIDER_FULL = '/v0/slider/full',
  SLIDER = '/v0/slider',
  ALL_PRODUCT = '/v0/product/all',
  PRODUCT = '/v0/product',
  PRODUCT_SKU = '/v0/product/sku',
  PRODUCT_UPLOAD_DESCRIPTION_FILE = '/v0/product/upload/description',
  PRODUCT_FULL = '/v0/product/full/',
  CATEGORY_ICON_UPLOAD = '/v0/category/upload/icon',
  PRODUCT_FULL_GIFT_CATEGORY = '/v0/product/full-gift-category',
  ATTACH_PRODUCT_TO_GIFT = '/v0/product/attach-to-gift',
}
